import { modifier } from 'ember-modifier';
import { resetScroll } from 'client-portal/utils/reset-scroll';

export default modifier(function resetScrollModifier(element) {
  resetScroll(element);
});
